var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100%"}},[_c('router-view',{staticClass:"view",staticStyle:{"min-height":"calc(100vh - 305px)"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }